export default ({ authGuard, guestGuard }) => [
  { path: '/', name: 'welcome', component: require('~/pages/welcome.vue'), alias: '/menu' },
  { path: '/home', name: 'home', component: require('~/pages/home.vue') },
  { path: '/register2', name: 'register2', component: require('~/pages/auth/register2.vue') },
  { path: '/:gid/:rid/menu', name: 'menu', component: require('~/pages/menu.vue') },
  { path: '/menu_item', name: 'menu_item', component: require('~/pages/menu_item.vue') },
  { path: '/cart', name: 'cart', component: require('~/pages/cart.vue') },
  { path: '/cart_item', name: 'cart_item', component: require('~/pages/cart_item.vue') },
  { path: '/promotion', name: 'promotion', component: require('~/pages/promotion.vue') },
  { path: '/outlets', name: 'outlets', component: require('~/pages/outlets.vue') },
  { path: '/checkout', name: 'checkout', component: require('~/pages/checkout.vue') },
  { path: '/payment', name: 'payment', component: require('~/pages/payment.vue') },
  { path: '/payment2', name: 'payment2', component: require('~/pages/payment2.vue') },
  { path: '/orders', name: 'orders', component: require('~/pages/orders.vue') },
  { path: '/order/:id', name: 'order', component: require('~/pages/order.vue'), props: true },
  { path: '/order2/:id', name: 'order2', component: require('~/pages/order2.vue'), props: true },
  { path: '/submit', name: 'submit', component: require('~/pages/submit.vue') },
  { path: '/info', name: 'info', component: require('~/pages/info.vue') },
  { path: '/cbs', name: 'cbs', component: require('~/pages/cbs.vue') },
  { path: '/bills', name: 'bills', component: require('~/pages/bills.vue') },
  { path: '/bill/:id', name: 'bill', component: require('~/pages/bill.vue'), props: true },
  { path: '/receipt/:id', name: 'receipt', component: require('~/pages/receipt.vue'), props: true },
  { path: '/paynow_instruction', name: 'paynow_instruction', component: require('~/pages/paynow_instruction.vue') },
  { path: '/pay_at_counter_instruction', name: 'pay_at_counter_instruction', component: require('~/pages/pay_at_counter_instruction.vue') },
  { path: '/areas', name: 'areas', component: require('~/pages/areas.vue') },
  { path: '/area1/:id', name: 'area1', component: require('~/pages/area1.vue'), props: true },
  { path: '/advertised_outlets', name: 'advertised_outlets', component: require('~/pages/advertised_outlets.vue') },
  { path: '/reservation_tnc', name: 'reservation_tnc', component: require('~/pages/reservation_tnc.vue') },
  { path: '/show_article/:submenu_id', name: 'show_article', component: require('~/pages/show_article.vue') },
  { path: '/password/reset', name: 'password.request', component: require('~/pages/auth/password/email.vue') },
  { path: '/password/reset/:token', name: 'password.reset', component: require('~/pages/auth/password/reset.vue') },
  { path: '/password/reset/:loyalty_group_id/:token', name: 'password.reset2', component: require('~/pages/auth/password/reset2.vue') },
  { path: '/password/reset/:loyalty_group_id/:group_id/:restaurant_id/:token', name: 'password.reset3', component: require('~/pages/auth/password/reset3.vue') },

  // Authenticated routes.
  ...authGuard([
    { path: '/profile', name: 'profile', component: require('~/pages/profile.vue') },
    { path: '/points', name: 'points', component: require('~/pages/points.vue') },
    { path: '/favors', name: 'favors', component: require('~/pages/favors.vue') },
    { path: '/inbox', name: 'inbox', component: require('~/pages/inbox.vue') },
    { path: '/receipts', name: 'receipts', component: require('~/pages/receipts.vue') },
    { path: '/mail/:id', name: 'mail', component: require('~/pages/mail.vue'), props: true },
    { path: '/addresses', name: 'addresses', component: require('~/pages/addresses.vue') },
    { path: '/custom_sets', name: 'custom_sets', component: require('~/pages/custom_sets.vue') },
    { path: '/reservations', name: 'reservations', component: require('~/pages/reservations.vue') },
    { path: '/membership_purchase', name: 'membership_purchase', component: require('~/pages/membership_purchase.vue') },
    { path: '/membership_purchased', name: 'membership_purchased', component: require('~/pages/membership_purchased.vue') },
    { path: '/my_vouchers', name: 'my_vouchers', component: require('~/pages/my_vouchers.vue') },
    { path: '/voucher/:id', name: 'voucher', component: require('~/pages/voucher.vue'), props: true }
  ]),

  // Guest routes.
  ...guestGuard([
    { path: '/guest_details', name: 'guest_details', component: require('~/pages/guest_details.vue') },
    { path: '/login', name: 'login', component: require('~/pages/auth/login.vue') },
    { path: '/register', name: 'register', component: require('~/pages/auth/register.vue') }
    // { path: '/password/reset', name: 'password.request', component: require('~/pages/auth/password/email.vue') },
    // { path: '/password/reset/:token', name: 'password.reset', component: require('~/pages/auth/password/reset.vue') }
  ]),

  { path: '*', component: require('~/pages/errors/404.vue') }
]



// WEBPACK FOOTER //
// ./src/router/routes.js